import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import './ProjectListPage.scss'
import ProjectItem from '../../Components/Project/ProjectItem'
import { withCookies, Cookies } from 'react-cookie'
import HeaderProject from '../../Components/Commons/HeaderProject'

import MediaQuery from 'react-responsive'

import * as actions from '../../Redux/reducer'
import { connect } from 'react-redux'

import { Button, Input, Space, Col, Row } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
class ProjectListPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            projects: [],
            user: [],
            searchInputValue: '',
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })

                this.loadProjects(res.data._id)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadProjects = (userId) => {
        axios
            .get(`${BACKEND_HOST}/users/${userId}/projects/`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                //console.log(res.data)
                this.setState({ projects: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderProject = () => {
        const searchInputValue = this.state.searchInputValue

        return this.state.projects
            .filter((project) => {
                if (searchInputValue.length === 0) {
                    return true
                }
                if (project.title.indexOf(searchInputValue) > -1) {
                    return true
                }
                if (project.address.jibunAddress.indexOf(searchInputValue) > -1) {
                    return true
                }

                return false
            })
            .map((list) => {
                return (
                    <ProjectItem
                        onClick={() => {
                            this.props.setCurrentPageScrollY(1, window.pageYOffset)
                        }}
                        list={list}
                        key={list._id}
                        history={this.props.history}
                        user={this.state.user}
                    />
                )
            })
    }

    changeSearchInputValue = (e) => {
        this.setState({ searchInputValue: e.target.value })
    }

    render() {
        // console.log(this.state);

        if (this.state.projects) {
            return (
                <div>
                    <HeaderProject />
                    <div className="section_wrap">
                        <div className="project_list_wrap common_list">
                            <div className="common_wrap">
                                <h1>나의 프로젝트</h1>
                                <h2>
                                    내가 진행하고 있는 프로젝트입니다.
                                    <br />
                                    프로젝트를 선택하면 프로젝트의 대시보드로 진입합니다.
                                </h2>

                                <MediaQuery minWidth={600}>
                                    <div
                                        className={'search-panel'}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'flex-end',
                                            marginBottom: 30,
                                        }}>
                                        <div style={{ width: '30%', marginRight: '10px' }}>
                                            <Input
                                                className="search-panel__search-input"
                                                prefix={<SearchOutlined />}
                                                placeholder="프로젝트명"
                                                value={this.state.searchInputValue}
                                                onChange={this.changeSearchInputValue}></Input>
                                        </div>
                                        <Button
                                            className="search-panel__reset-button"
                                            onClick={() => this.setState({ searchInputValue: '' })}>
                                            검색어 초기화
                                        </Button>
                                    </div>
                                </MediaQuery>
                                <MediaQuery maxWidth={600}>
                                    <div
                                        className={'search-panel'}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            marginBottom: 30,
                                        }}>
                                        <div style={{ width: '60%', marginRight: '5%' }}>
                                            <Input
                                                className="search-panel__search-input"
                                                prefix={<SearchOutlined />}
                                                placeholder="프로젝트명"
                                                value={this.state.searchInputValue}
                                                onChange={this.changeSearchInputValue}></Input>
                                        </div>
                                        <Button
                                            className="search-panel__reset-button"
                                            onClick={() => this.setState({ searchInputValue: '' })}>
                                            검색어 초기화
                                        </Button>
                                    </div>
                                </MediaQuery>

                                {this.state.projects.length !== 0 ? (
                                    <ul className="project_list">{this.renderProject()}</ul>
                                ) : (
                                    <div className="no_project_wrap">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="55"
                                            height="63"
                                            viewBox="0 0 55 63">
                                            <defs>
                                                <linearGradient id="no_project1" x1="50%" x2="0%" y1="50%" y2="100%">
                                                    <stop offset="0%" stopColor="#E1E4EA" />
                                                    <stop offset="100%" stopColor="#D6D7DB" />
                                                </linearGradient>
                                                <path id="no_project2" d="M31 0v23h23z" />
                                                <filter
                                                    id="no_project3"
                                                    width="113%"
                                                    height="113%"
                                                    x="-6.5%"
                                                    y="-6.5%"
                                                    filterUnits="objectBoundingBox">
                                                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                    <feGaussianBlur
                                                        in="shadowOffsetOuter1"
                                                        result="shadowBlurOuter1"
                                                        stdDeviation=".5"
                                                    />
                                                    <feColorMatrix
                                                        in="shadowBlurOuter1"
                                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                                    />
                                                </filter>
                                            </defs>
                                            <g fill="none" fillRule="evenodd">
                                                <path
                                                    fill="#E2E4E9"
                                                    d="M3 1h27.952L54 23.997V60a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3z"
                                                />
                                                <g
                                                    stroke="#F5F7FA"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2.4">
                                                    <path d="M37 32.733L17.733 52M17.733 32.733L37 52" />
                                                </g>
                                                <g transform="translate(0 1)">
                                                    <use
                                                        fill="#000"
                                                        filter="url(#no_project3)"
                                                        xlinkHref="#no_project2"
                                                    />
                                                    <use fill="url(#no_project1)" xlinkHref="#no_project2" />
                                                </g>
                                            </g>
                                        </svg>

                                        <p>아직 등록된 프로젝트가 없습니다.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderProject />
                <div className="section_wrap" />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    lastScrollYPerPage: state.globalReducer.lastScrollYPerPage,
})

const mapDispatchToProps = (dispatch) => ({
    setCurrentPageScrollY: (page, currentPageScrollY) =>
        dispatch(actions.setCurrentPageScrollY(page, currentPageScrollY)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(ProjectListPage))



// WEBPACK FOOTER //
// ./Src/Containers/Project/ProjectListPage.js